import React from 'react';
import { DimensionGrid } from '../shared/DimensionBar';

export function DimensionCards({ dimensions, onDimensionClick, activeDimension }) {
  return (
    <div className="msml-card !p-4 !gap-3 msml-slide-up" style={{ animationDelay: '0.05s' }} data-testid="dimensions-card">
      <span className="msml-label">Six Dimensions</span>
      <DimensionGrid
        dimensions={dimensions}
        activeDimension={activeDimension}
        onDimensionClick={(key) => onDimensionClick?.(key)}
      />
    </div>
  );
}
